import scooterSrc from '../../assets/iconfinder_Kick_Scooter_3362526.svg'
import bikeSrc from '../../assets/041-bike.svg'
import beerSrc from '../../assets/beer-mug.svg'
import carSrc from '../../assets/001-car.svg'
import tramSrc from '../../assets/014-train.svg'
import busStationSrc from '../../assets/007-bus-stop.svg'
import chargingSrc from '../../assets/033-plug.svg'
import parkingLotSrc from '../../assets/032-parking-meter.svg'

import safetySrc from '../../assets/040-traffic-light.svg'
import bikeLaneSRc from '../../assets/024-gps.svg'

import { IWish } from 'types'

export const getImageSrcForWish = (wish: IWish['type']): string => {
  switch (wish) {
    case 'scooter':
      return scooterSrc
    case 'bike':
      return bikeSrc
    case 'beer':
      return beerSrc
    case 'car':
      return carSrc
    case 'tram':
      return tramSrc
    case 'bus':
      return busStationSrc
    case 'charging':
      return chargingSrc
    case 'parking-lot':
      return parkingLotSrc
    case 'safety':
      return safetySrc
    case 'bike-lane':
      return bikeLaneSRc
  }
}

export const wishCategories: (IWish & { imageSrc: string })[] = [
  {
    type: 'scooter',
    name: 'E-Scooter',
    imageSrc: getImageSrcForWish('scooter'),
  },
  {
    type: 'bike',
    name: 'Fahrrad',
    imageSrc: getImageSrcForWish('bike'),
  },
  {
    type: 'tram',
    name: 'Straßenbahn',
    imageSrc: getImageSrcForWish('tram'),
  },
  {
    type: 'car',
    name: 'Auto',
    imageSrc: getImageSrcForWish('car'),
  },
  {
    type: 'bus',
    name: 'Busstation',
    imageSrc: getImageSrcForWish('bus'),
  },
  {
    type: 'safety',
    name: 'Mehr Sicherheit',
    imageSrc: getImageSrcForWish('safety'),
  },
  {
    type: 'bike-lane',
    name: 'Fahrradweg',
    imageSrc: getImageSrcForWish('bike-lane'),
  },
  {
    type: 'beer',
    name: 'Bier',
    imageSrc: getImageSrcForWish('beer'),
  },
  {
    type: 'charging',
    name: 'Lademöglichkeit',
    imageSrc: getImageSrcForWish('charging'),
  },
  {
    type: 'parking-lot',
    name: 'Parkplatz',
    imageSrc: getImageSrcForWish('parking-lot'),
  },
]



// WEBPACK FOOTER //
// ./src/components/wishes/wishes.ts